<section class="flex flex-col h-[100%] pr-4">
    <h1 class="title mb-3">Reset Password for
        {{ user?.name ? user?.name : user?.firstName + ' ' + user?.lastName }}</h1>

    <div class="flex flex-col my-3 grow gap-y-4">
        <text-field placeholder="Enter New Password" label="New Password" [control]="getControl('password')"
            [error]="getErrorMessage('password')" [type]="type">
        </text-field>

        <text-field placeholder="Repeat Password" label="Repeat Password" [control]="getControl('confirmPassword')"
            [error]="getErrorMessage('confirmPassword')" [type]="type">
        </text-field>

        <checkbox class="mr-2" [value]="showPasswords" label="Show Passwords" (change)="toggleType()"></checkbox>


        <p class="label">Password requirements:</p>
        <ul class="max-w-md space-y-1 text-[var(--text-primary)]">
            <li class="flex items-center ml-3"
                [ngClass]="{'text-[var(--accent-error)]': getControl('password').hasError('minlength') || getControl('password').hasError('maxlength') }">
                At least 4 characters (and up to 60)

                @if (getControl('password').valid) {
                    <svg-icon name="checkbox" color="var(--btn-txt-secondary)"
                        size="SM" class="ml-2">
                    </svg-icon>
                }
            </li>

            <li class="flex items-center ml-3" [ngClass]="{'text-[var(--accent-error)]': !match}">
                Passwords must match

                @if (getControl('password').valid && match) {
                    <svg-icon name="checkbox" class="ml-2" size="SM"
                        color="var(--btn-txt-secondary)"></svg-icon>
                }
            </li>
        </ul>

    </div>


    <div class="w-max h-max content-end">
        <common-button label="Submit" size="L" class="place-self-end" (click)="confirm()"
            [disabled]="form.invalid || !match">
        </common-button>
    </div>
</section>